export default "__VITE_PUBLIC_ASSET__747ad5de__"